import { render, staticRenderFns } from "./SysFormModal.vue?vue&type=template&id=32f8bf9d"
import script from "./SysFormModal.vue?vue&type=script&lang=js"
export * from "./SysFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports